import React from "react";

import HomeUI from "../../../../ui/homeUI/_index";


const FinishLate = () => {
  return (
    <HomeUI />
  )
}

export default FinishLate